import { render, staticRenderFns } from "./GroupBlogs.vue?vue&type=template&id=0e8f65d6&"
import script from "./GroupBlogs.vue?vue&type=script&lang=ts&"
export * from "./GroupBlogs.vue?vue&type=script&lang=ts&"
import style0 from "./GroupBlogs.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports